import * as React from "react"
export const Svg_033 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M41.994 43.162c-.864.499-1.778.87-2.722 1.113V55.41h8.701V37.468a10.8 10.8 0 0 1-1.605.921 10.681 10.681 0 0 1-4.374 4.772Z"
      />
      <path
        fill="url(#c)"
        d="M35.674 44.564A10.682 10.682 0 0 1 29.5 46.51c-2.23 0-4.357-.67-6.174-1.945a11.49 11.49 0 0 1-.143.012V59h12.632V44.576a8.403 8.403 0 0 1-.14-.012Z"
      />
      <path
        fill="url(#d)"
        d="M17.006 43.162a10.682 10.682 0 0 1-4.374-4.772 10.816 10.816 0 0 1-1.608-.923v17.944h8.701V44.273a10.794 10.794 0 0 1-2.719-1.112Z"
      />
      <path
        fill="url(#e)"
        d="M29.5 9.776c-6.477 0-11.746 5.27-11.746 11.746 0 6.477 5.27 11.746 11.746 11.746 6.477 0 11.746-5.27 11.746-11.746 0-6.477-5.27-11.746-11.746-11.746Zm0 18.435c-3.689 0-6.69-3-6.69-6.69 0-3.688 3.001-6.689 6.69-6.689 3.688 0 6.69 3.001 6.69 6.69 0 3.688-3.002 6.69-6.69 6.69Z"
      />
      <path
        fill="url(#f)"
        d="M29.5 18.29a3.236 3.236 0 0 0-3.232 3.232 3.236 3.236 0 0 0 3.232 3.232 3.236 3.236 0 0 0 3.232-3.232A3.235 3.235 0 0 0 29.5 18.29Z"
      />
      <path
        fill="url(#g)"
        d="m49.558 17.122-.61-.811.123-1.007a7.346 7.346 0 0 0-4.4-7.622l-.934-.397-.397-.934a7.347 7.347 0 0 0-7.622-4.4l-1.007.123-.81-.61a7.347 7.347 0 0 0-8.801 0l-.811.61-1.008-.123a7.346 7.346 0 0 0-7.62 4.4l-.397.934-.935.397a7.346 7.346 0 0 0-4.4 7.621l.123 1.008-.61.81a7.346 7.346 0 0 0 0 8.801l.61.81-.123 1.008a7.346 7.346 0 0 0 4.4 7.622l.934.397.397.934a7.346 7.346 0 0 0 7.622 4.4l1.007-.124.81.611a7.346 7.346 0 0 0 8.801 0l.811-.61 1.007.123c.295.036.589.054.88.054 2.898 0 5.59-1.742 6.742-4.454l.396-.934.935-.397a7.346 7.346 0 0 0 4.4-7.622l-.123-1.007.61-.81a7.346 7.346 0 0 0 0-8.801ZM29.5 36.725c-8.383 0-15.203-6.82-15.203-15.203S21.117 6.319 29.5 6.319s15.203 6.82 15.203 15.203-6.82 15.203-15.203 15.203Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={41.285}
        x2={50.541}
        y1={40.16}
        y2={47.425}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={26.104}
        x2={33.329}
        y1={46.73}
        y2={56.962}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={13.036}
        x2={22.293}
        y1={40.159}
        y2={47.424}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={23.187}
        x2={34.345}
        y1={13.3}
        y2={31.359}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={27.763}
        x2={30.833}
        y1={19.26}
        y2={24.229}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={17.932}
        x2={38.378}
        y1={6.457}
        y2={39.546}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h59v59H0z" />
      </clipPath>
    </defs>
  </svg>
)